// extracted by mini-css-extract-plugin
export default {"container":"Checkbox_container__HciKu","checkmark":"Checkbox_checkmark__6DYoj"};